import moment from "moment";
import { validateYear } from "../../../utils/dateValidation";

export const RULES_DEPARTURE = {
    departure_date: {
        required: {
            value: true,
            message: "Ce champ est obligatoire",
        },
        validate: validateYear,
        // validate: (value) => {
        //     const selectedDate = moment(value);
        //     const today = moment().startOf("day"); // Mettre l'heure à 00:00:00 pour comparer uniquement les dates
        //     return (
        //         selectedDate.isSameOrAfter(today) ||
        //         "La date ne peut pas être antérieure à aujourd'hui"
        //     );
        // },
    },
};
